import { Cidade } from './Cidade';

export class Bairro {
    id = 0;
    cidade = new Cidade();
    idCidade = 0;
    descricao = '';
}